import { $GQL } from '@GQL/index';

export async function updateSalesGoals(data: Record<string, any>) {
	const query = `
		mutation UpdateSalesGoals($data: JSONObject!) {
			upsertSalesGoals(data: $data) {
				id
			}
		}
	`;

	const result = await $GQL.request(query, { data });
	return result.upsertSalesGoals;
}
